// When the interface re-reads the signed-in account's rights (`GET /auth/me`), so that menus and buttons follow a
// change made by an administrator without a page reload. UX only: the server already refuses at once whatever was revoked.
//
// "visible": the person comes back to the tab, at most once a minute.
// "forbidden": the server has just answered 403: re-read promptly, but never in a burst (several requests refused together).
// The caller spaces it from the previous 403-triggered read only, never from the initial one.
export const RIGHTS_REFRESH_MIN_INTERVAL_MS = { visible: 60_000, forbidden: 5_000 };

export function shouldRefreshRights(reason, now, lastRefreshAt) {
  const minInterval = RIGHTS_REFRESH_MIN_INTERVAL_MS[reason];
  if (minInterval === undefined) return false;
  return lastRefreshAt === null || now - lastRefreshAt >= minInterval;
}
